export default __webpack_public_path__ + "static/media/session11.e9af4fd3.svg";